import { JSX } from 'react'

import { IconProps } from '../../icon'

const Image: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M30.5641 8H17.4359C12.2338 8 8 12.2338 8 17.4359V30.5641C8 35.7662 12.2338 40 17.4359 40H30.5641C35.7662 40 40 35.7662 40 30.5641V17.4359C40 12.2338 35.7662 8 30.5641 8ZM37.5385 30.5641C37.5385 34.4041 34.4041 37.5385 30.5641 37.5385H17.4359C13.5959 37.5385 10.4615 34.4041 10.4615 30.5641V17.4359C10.4615 13.5959 13.5959 10.4615 17.4359 10.4615H30.5641C34.4041 10.4615 37.5385 13.5959 37.5385 17.4359V30.5641Z'
      fill='black'
    />
    <path
      d='M32.9764 27.2821L31.4831 28.7754C30.9087 29.3498 30.0226 29.3826 29.399 28.8739L23.1959 23.7046C21.7518 22.5067 19.7169 22.4575 18.2236 23.5734L13.4154 27.1836C12.8738 27.5939 12.759 28.3652 13.1692 28.9067C13.5795 29.4482 14.3508 29.5631 14.8923 29.1528L19.7005 25.5426C20.2749 25.1159 21.0626 25.1323 21.6205 25.5918L27.8236 30.7611C28.5785 31.3846 29.481 31.6964 30.3836 31.6964C31.4174 31.6964 32.4349 31.3026 33.2226 30.5149L34.7159 29.0216C35.1918 28.5457 35.1918 27.758 34.7159 27.2821C34.24 26.8062 33.4523 26.8062 32.9764 27.2821Z'
      fill='black'
    />
    <path
      d='M29.7436 21.9487C31.7785 21.9487 33.4359 20.2913 33.4359 18.2564C33.4359 16.2215 31.7785 14.5641 29.7436 14.5641C27.7087 14.5641 26.0513 16.2215 26.0513 18.2564C26.0513 20.2913 27.7087 21.9487 29.7436 21.9487ZM29.7436 17.0256C30.4164 17.0256 30.9744 17.5836 30.9744 18.2564C30.9744 18.9292 30.4164 19.4872 29.7436 19.4872C29.0708 19.4872 28.5128 18.9292 28.5128 18.2564C28.5128 17.5836 29.0708 17.0256 29.7436 17.0256Z'
      fill='black'
    />
  </svg>
)

export default Image
